// Keep in sync with mobile-app/src/features/tasks/utils/formatted-task-text.ts.
export type FormattedTaskTextSegmentType = 'text' | 'strong' | 'danger' | 'large';

export interface FormattedTaskTextSegment {
  type: FormattedTaskTextSegmentType;
  text: string;
}

const MARKERS: Array<{
  type: Exclude<FormattedTaskTextSegmentType, 'text'>;
  open: string;
  close: string;
}> = [
  { type: 'strong', open: '**', close: '**' },
  { type: 'danger', open: '[\u7ea2\u8272]', close: '[/\u7ea2\u8272]' },
  { type: 'large', open: '[\u5927\u5b57]', close: '[/\u5927\u5b57]' },
];

function pushText(segments: FormattedTaskTextSegment[], text: string): void {
  if (!text) return;
  const previous = segments[segments.length - 1];
  if (previous?.type === 'text') {
    previous.text += text;
    return;
  }
  segments.push({ type: 'text', text });
}

function parseLine(line: string): FormattedTaskTextSegment[] {
  const segments: FormattedTaskTextSegment[] = [];
  let cursor = 0;

  while (cursor < line.length) {
    const marker = MARKERS.find((item) => line.startsWith(item.open, cursor));
    if (!marker) {
      pushText(segments, line[cursor]);
      cursor += 1;
      continue;
    }

    const contentStart = cursor + marker.open.length;
    const contentEnd = line.indexOf(marker.close, contentStart);
    if (contentEnd < 0) {
      pushText(segments, line.slice(cursor));
      break;
    }

    const text = line.slice(contentStart, contentEnd);
    if (text) {
      segments.push({ type: marker.type, text });
    } else {
      pushText(segments, line.slice(cursor, contentEnd + marker.close.length));
    }
    cursor = contentEnd + marker.close.length;
  }

  return segments.length > 0 ? segments : [{ type: 'text', text: line }];
}

export function parseFormattedTaskText(value: string): FormattedTaskTextSegment[][] {
  return value
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map(parseLine);
}
